import { FOUNDED } from '../constants';

export const getAge = () => {
  const today = new Date();
  return today.getFullYear() - FOUNDED;
};
